<template>
    <div>
        <HeaderHome />
        <div class="container flex flex-col gap-4 my-8">
            <HomeSponsors />
            <HomeCategories />
            <HomeNewProducts v-if="globalConfig.Features.PRODUCT_SPOTLIGHTS" />
        </div>
        <HomeBlog />
    </div>
</template>
<script setup lang="ts">
const { t } = useI18n();
const userInfo = useStateUserInfo();
const globalConfig = useStateGlobalConfig();

definePageMeta({
    layout: "headless",
});

useSeoMeta({
    title: t("Global.TitleDefault"),
    ogTitle: t("Global.TitleDefault"),
    description: t("Home.Page_MetaDescription"),
    ogDescription: t("Home.Page_MetaDescription"),
});

// This adds the Multiview tracking pixel, but only here on the home page if it is the entry page
if (userInfo.value.AcceptsAnalyticsCookies) {
    useHead({
        script: [
            {
                src: "//assets.adobedtm.com/175f7caa2b90/392d111f1591/launch-0ed7304f3505.min.js",
                async: true,
            },
        ],
    });
}
</script>
